<template>
  <v-dialog :value="showModalChangeUser" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer>
        <v-card-title class="text-sm-left font-weight-bold">
          Bàn giao contact cho người phụ trách mới
          <div class="subtitle-modal-change-user">( Trước khi chuyển module )</div>
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển người phụ trách"
              >
<!--                <common-select-user-->
<!--                  v-model="userId"-->
<!--                  :items="users"-->
<!--                  color="primary"-->
<!--                  item-text="fullName"-->
<!--                  item-value="id"-->
<!--                  :error-messages="errors"-->
<!--                />-->

                <v-autocomplete
                  v-model="userObj"
                  :items="users"
                  color="primary"
                  item-text="fullName"
                  return-object
                  :error-messages="errors"
                  @change="changeUser()"
                />
              </validation-provider>
                <div style="color: red; text-align: left"
                     v-if="showError">Chọn người phụ trách là bắt buộc</div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0">
<!--          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu Lại</v-btn>-->
<!--          <v-spacer />-->

          <v-btn color="primary" @click="confirmChangeUser">Xác nhận</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');
export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    showModalChangeUser: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      userObj: {},
      users: [],
      loading: '',
      showError: false
    };
  },
  created() {
    this.getListUserSameModule();
  },
  methods: {
    hideModal: function() {
      Bus.$emit('close-modal-change-user')
    },
    async confirmChangeUser() {
        if(!_.isEmpty(this.userObj)) {
            this.showError = false
            this.$emit('updateAfterChangePersonInCharge', this.userObj)
        } else {
            this.showError = true
        }
    },
    async getListUserSameModule() {
      const response = await ContactRepository.listUserSameModule({userId: this.user.id});
      if (response.success) {
        this.users = _.get(response, 'data', []).map(user => {
            return {
                id: user.id,
                fullName: user.fullName ? user.fullName : ""
            }
        });
      } else {
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: _.get(response, "message", ""),
        })
      }
    },
      changeUser() {
        if(_.isEmpty(this.userObj)) {
            this.showError = true
        } else {
            this.showError = false
        }
      }
  }
};
</script>
<style scoped>
  /deep/.subtitle-modal-change-user {
    font-weight: 400;
    font-size: 14px;
    font-style: italic;
  }
</style>